import { render, staticRenderFns } from "./NewProductDialog.vue?vue&type=template&id=2b9d631a&"
import script from "./NewProductDialog.vue?vue&type=script&lang=js&"
export * from "./NewProductDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewProductDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VToolbar,VToolbarTitle})


/* hot reload */
if (module.hot) {
  var api = require("/Users/musili/musilidev/webroot/work-bmm/01_DEX/dex/front-end/web-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b9d631a')) {
      api.createRecord('2b9d631a', component.options)
    } else {
      api.reload('2b9d631a', component.options)
    }
    module.hot.accept("./NewProductDialog.vue?vue&type=template&id=2b9d631a&", function () {
      api.rerender('2b9d631a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenant/views/Products/Components/NewProductDialog.vue"
export default component.exports